import azMessages from "./messages/az.json";
import trMessages from "./messages/tr_TR.json";

const messages = {
  az: azMessages,
  "tr-tr": trMessages
};

export default messages;
